/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";
// query GetSalesReport($filter: CostumeTypeFilterInput) {
//   getSalesReport(filter: $filter) {
export const GET_SECTION_OPTIONS = gql`

query GetSalesReport($filter: SalesFilterInput) {
  getSalesReport(filter: $filter) {
      count
      limit
      skip
      content {
        section {
          name
        }
        Activecount
        Deletedcount
        sectionOptType
      }
    }
  }
`;
export const GET_ALL_SECTION_OPTIONS = gql`
  query GetCostumeTypes($filter: CostumeTypeFilterInput) {
    getCostumeTypes(filter: $filter) {
      count
      limit
      skip
      content {
        name
        sectionSpecificInvites
        specialInvites
        id
        defaultInvites
        section {
          name
        }
        inventoryDetail {
          defaultInvitesRemaining
          defaultInvitesUsed
          sectionSpecificInvitesRemaining
          sectionSpecificInvitesUsed
          specialInvitesRemaining
          specialInvitesUsed
        }
      }
    }
  }
`;

// $input: RoleListInput

// getListOfRole(input: $input) {
//   totalCount
//   data
// }
